import React from "react";
import PropTypes from "prop-types";
import { Form } from "react-bootstrap";

const FormControlTextArea = ({
  placeholder,
  name,
  value,
  onChange,
  rows,
  isInvalid,
  feedback,
  autoComplete = "off",
  isDisabled = false,
}) => {
  return (
    <>
      <Form.Control
        as="textarea"
        rows={rows || 3}
        placeholder={placeholder}
        name={name}
        value={value}
        onChange={onChange}
        isInvalid={isInvalid}
        className="textarea border-radius"
        autoComplete={autoComplete}
        disabled={isDisabled}
      />
      {isInvalid && (
        <Form.Control.Feedback type="invalid">{feedback}</Form.Control.Feedback>
      )}
    </>
  );
};

FormControlTextArea.propTypes = {
  placeholder: PropTypes.string,
  name: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  rows: PropTypes.number,
  isInvalid: PropTypes.bool,
  feedback: PropTypes.string,
  isDisabled: PropTypes.bool,
};

export default FormControlTextArea;
